import gql from 'graphql-tag';
import formBlockFieldCustomizeItemFragment from './blockFieldCustomizeItem';

export default gql`
  fragment formPostCustomizeItemTextFragment on FormPostCustomizeItemText {
    id
    value
    formBlockFieldCustomizeItemId
    formBlockFieldCustomizeItem {
      ...formBlockFieldCustomizeItemFragment
    }
    createdAt
    updatedAt
  }
  ${formBlockFieldCustomizeItemFragment}
`;
